import React from "react";

import { Typography } from "@mui/material";

const CustomAlert = ({ message, type, onClose }) => {
    const alertStyles = {
        success: {
            backgroundColor: "#d4edda",
            color: "#155724",
            borderColor: "#c3e6cb",
        },
        error: {
            backgroundColor: "#f8d7da",
            color: "#721c24",
            borderColor: "#f5c6cb",
        },
    };

    const style = alertStyles[type] || alertStyles.error;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
                marginBottom: "16px",
                border: `1px solid ${style.borderColor}`,
                borderRadius: "4px",
                backgroundColor: style.backgroundColor,
                color: style.color,
            }}
        >
            <Typography>{message}</Typography>
            <button
                onClick={onClose}
                style={{
                    background: "none",
                    border: "none",
                    fontSize: "16px",
                    cursor: "pointer",
                    color: style.color,
                    padding: "0 8px",
                }}
                aria-label="close"
            >
                ×
            </button>
        </div>
    );
};

export default CustomAlert;